var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonialsBgBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 967,
    height: 217,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.791 216.259C215.791 97.2995 312.264 0.863037 431.27 0.863037C550.275 0.863037 646.748 97.2995 646.748 216.259",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.217 216.258C207.217 106.815 303.69 17.9924 422.695 17.9924C541.7 17.9924 638.174 106.815 638.174 216.258",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.652 216.256C198.652 116.33 295.126 35.1201 414.131 35.1201C533.136 35.1201 629.609 116.33 629.609 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.771 216.254C189.771 125.845 286.245 52.5659 405.25 52.5659C524.255 52.5659 620.729 125.845 620.729 216.254",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.199 216.256C181.199 135.363 277.673 69.6976 396.678 69.6976C515.683 69.6976 612.156 135.363 612.156 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.627 216.259C172.627 144.883 269.1 86.8306 388.105 86.8306C507.111 86.8306 603.584 144.883 603.584 216.259",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.064 216.26C164.064 154.402 260.538 104.28 379.543 104.28C498.548 104.28 595.339 154.402 595.339 216.26",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.492 216.256C155.492 163.914 251.966 121.405 370.971 121.405C489.976 121.405 586.449 163.914 586.449 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.609 216.254C146.609 173.429 243.083 138.534 362.088 138.534C481.093 138.534 577.566 173.429 577.566 216.254",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.039 216.256C138.039 182.947 234.513 155.983 353.518 155.983C472.523 155.983 568.996 182.947 568.996 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.475 216.256C129.475 192.464 225.948 173.113 344.953 173.113C463.958 173.113 560.432 192.464 560.432 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.902 216.256C120.902 201.981 217.376 190.244 336.381 190.244C455.386 190.244 551.859 201.981 551.859 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M431.274 216.256C431.274 97.2962 334.801 0.859741 215.796 0.859741C96.7908 0.859741 0 97.2962 0 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M439.844 216.257C439.844 106.814 343.37 17.9913 224.365 17.9913C105.36 17.9913 8.88672 106.814 8.88672 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.726 216.257C448.726 116.331 352.252 35.1212 233.247 35.1212C114.242 35.1212 17.4512 116.331 17.4512 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M457.296 216.252C457.296 125.842 360.822 52.5634 241.817 52.5634C122.812 52.5634 26.0215 125.842 26.0215 216.252",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M465.866 216.258C465.866 135.366 369.393 69.7001 250.388 69.7001C131.383 69.7001 34.5918 135.366 34.5918 216.258",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M474.435 216.257C474.435 144.881 377.961 86.8291 258.956 86.8291C139.951 86.8291 43.1602 144.881 43.1602 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M483.002 216.255C483.002 154.396 386.528 104.274 267.523 104.274C148.518 104.274 52.0449 154.396 52.0449 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M491.89 216.255C491.89 163.913 395.416 121.405 276.411 121.405C157.406 121.405 60.6152 163.913 60.6152 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.459 216.257C500.459 173.432 403.986 138.537 284.98 138.537C165.975 138.537 69.502 173.432 69.502 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M509.023 216.255C509.023 182.946 412.55 155.982 293.545 155.982C174.54 155.982 78.0664 182.946 78.0664 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M517.594 216.255C517.594 192.463 421.12 173.113 302.115 173.113C183.11 173.113 86.6367 192.463 86.6367 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M526.164 216.257C526.164 201.982 429.691 190.245 310.686 190.245C191.68 190.245 95.207 201.982 95.207 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M534.726 216.257C534.726 211.499 438.253 207.692 319.248 207.692C200.243 207.692 103.77 211.499 103.77 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 216.258C112.338 211.499 208.811 207.693 327.816 207.693C410.009 207.693 481.412 209.596 517.907 212.134",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M862.551 216.256C862.551 97.2961 766.077 0.859619 647.072 0.859619C528.067 0.859619 431.594 97.2961 431.594 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M871.12 216.255C871.12 106.812 774.647 17.9887 655.642 17.9887C536.637 17.9887 439.846 106.812 439.846 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M880 216.257C880 116.331 783.527 35.1211 664.522 35.1211C545.516 35.1211 449.043 116.331 449.043 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M888.572 216.252C888.572 125.842 792.099 52.5632 673.094 52.5632C554.089 52.5632 457.615 125.842 457.615 216.252",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M897.143 216.258C897.143 135.366 800.669 69.7 681.664 69.7C562.659 69.7 466.186 135.366 466.186 216.258",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M905.711 216.257C905.711 144.881 809.237 86.8289 690.232 86.8289C571.227 86.8289 474.754 144.881 474.754 216.257",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M914.277 216.259C914.277 154.4 817.804 104.278 698.799 104.278C579.794 104.278 483.32 154.4 483.32 216.259",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M922.848 216.255C922.848 163.912 826.374 121.404 707.369 121.404C588.364 121.404 491.891 163.912 491.891 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M931.738 216.255C931.738 173.43 835.265 138.535 716.26 138.535C597.255 138.535 500.781 173.43 500.781 216.255",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M940.305 216.254C940.305 182.945 843.831 155.981 724.826 155.981C605.821 155.981 509.348 182.945 509.348 216.254",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M948.869 216.256C948.869 192.464 852.396 173.113 733.391 173.113C614.386 173.113 517.912 192.464 517.912 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M957.436 216.254C957.436 201.979 860.962 190.242 741.957 190.242C622.952 190.242 526.479 201.979 526.479 216.254",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M966.002 216.256C966.002 211.498 869.528 207.691 750.523 207.691C631.518 207.691 535.045 211.498 535.045 216.256",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M543.611 216.256C543.611 211.497 640.085 207.691 759.09 207.691C841.283 207.691 912.686 209.594 949.181 212.132",
    stroke: "#FFD6A9",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsBgBottom);
export default __webpack_public_path__ + "static/media/testimonials-bg-bottom.e873d5910f53cca91d04b7f74b5ba2d6.svg";
export { ForwardRef as ReactComponent };